import { Controller } from '@hotwired/stimulus'
import Helpers from '../helpers'
import { submitInvestRobotForm, submitInvestRobotCancelForm } from './mixins/invest_robot_form.js'

export default class PlanInvestmentController extends Controller {
  static targets = [
    'amountInput',
    'hiddenAmountInput',
    'submitButton',
    'subscriptionForm',
    'successMessageContainer',
    'successModal',
    'createModal',
  ];

  static values = {
    errorMessage: String,
    notEnoughMoneyModalId: String,
  }

  checkAmountAndOpenCreateModal() {
    if (this.subscriptionFormTarget.reportValidity()) {
      const amount = this.amountInputTarget.value;
      const prefixLabel = this.submitButtonTarget.dataset.prefixLabel;

      this.hiddenAmountInputTarget.value = amount;
      this.submitButtonTarget.value = `${prefixLabel} ${Helpers.integerCurrencyFormater.format(amount)}`;
      this.submitButtonTarget.textContent = this.submitButtonTarget.value;

      this.openCreateModal();
    }
  }

  openCreateModal() {
    (new bootstrap.Modal(`#${this.createModalTarget.id}`)).show();
  }

  openEditModal(event) {
    (new bootstrap.Modal(`#${event.target.dataset.modalId}`)).show();
  }

  openCancelModal(event) {
    (new bootstrap.Modal(`#${event.target.dataset.modalId}`)).show();
  }

  submitCreateForm(event) {
    return this.submitInvestmentForm(event, { handleAlreadyExists: true });
  }

  submitUpdateForm(event) {
    return this.submitInvestmentForm(event);
  }

  async submitInvestmentForm(event, { handleAlreadyExists = false } = {}) {
    event.preventDefault();

    await submitInvestRobotForm(event.target, {
      onSuccess: (result) => {
        this.successMessageContainerTarget.innerHTML = result.success_message_html;
        (new bootstrap.Modal(`#${this.successModalTarget.id}`)).show();
      },
      onAlreadyExists: handleAlreadyExists ? () => window.location.reload() : null,
      onInsufficientFunds: () => (new bootstrap.Modal(`#${this.notEnoughMoneyModalIdValue}`)).show(),
      onError: (result) => toastr.error(result?.errors || this.errorMessageValue),
    });
  }

  async submitCancelForm(event) {
    event.preventDefault();

    await submitInvestRobotCancelForm(event.target, {
      onSuccess: () => window.location.reload(),
      onError: () => toastr.error(this.errorMessageValue),
    });
  }

  reloadPage() {
    window.location.reload();
  }
}
